const DEFAULT_LOCALE = 'en-US';

export function formatMonthYear(
    dateInput: Date | string | number,
    locale: string = DEFAULT_LOCALE
): string {
    if (!dateInput) {
        return 'טרם נקבע';
    }
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) {
        return '';
    }
    return new Intl.DateTimeFormat(locale, {
        month: '2-digit',
        year: 'numeric',
    }).format(date);
}